import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=4f599ea2&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"
import style0 from "./SettingsView.vue?vue&type=style&index=0&id=4f599ea2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f599ea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/votech/Documents/project/web/wave-writer-joecig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f599ea2')) {
      api.createRecord('4f599ea2', component.options)
    } else {
      api.reload('4f599ea2', component.options)
    }
    module.hot.accept("./SettingsView.vue?vue&type=template&id=4f599ea2&scoped=true", function () {
      api.rerender('4f599ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SettingsView.vue"
export default component.exports